export default {
  'exception-403.exception.back': '返回首页',
  'exception-403.description.403': '抱歉，你无权访问该页面',
};
